import React from 'react';
import classNames from 'classnames';

const ProjectAvatar = ({ className, project }) => {
  return (
    <div className={classNames(
      className,
      "overflow-hidden relative",
    )}>
      <img
        className="w-full h-full"
        src={`https://api.dicebear.com/7.x/initials/svg?scale=100&seed=${project.name}`}
        width="32"
        height="32"
        alt={project.name}
      />
    </div>
  );
};

export default ProjectAvatar;
